<template>
  <div
    v-if="open"
    class="lm-confirm"
    role="dialog"
    aria-modal="true"
    :aria-labelledby="titleId"
    :aria-describedby="descId"
    @click.self="$emit('cancel')"
    @keydown.esc.stop.prevent="$emit('cancel')"
    @keydown.tab="trapFocus"
  >
    <div class="lm-confirm-card" ref="card">
      <h2 :id="titleId">{{ title }}</h2>
      <p :id="descId">{{ description }}</p>
      <div class="lm-confirm-actions">
        <button type="button" class="btn-st-tr" ref="cancelBtn" @click="$emit('cancel')">
          {{ cancelLabel }}
        </button>
        <button
          type="button"
          :class="danger ? 'btn-st-red' : 'btn-st-viol'"
          @click="$emit('confirm')"
        >
          {{ confirmLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
let confirmSeq = 0;

export default {
  name: "ConfirmDialog",
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: "" },
    description: { type: String, default: "" },
    confirmLabel: { type: String, default: "" },
    cancelLabel: { type: String, default: "" },
    danger: { type: Boolean, default: true },
  },
  data() {
    return {
      titleId: `lm-confirm-title-${++confirmSeq}`,
      descId: `lm-confirm-desc-${confirmSeq}`,
      returnFocus: null,
    };
  },
  watch: {
    open(isOpen) {
      if (isOpen) {
        this.returnFocus = document.activeElement;
        this.$nextTick(() => {
          if (this.$refs.cancelBtn) this.$refs.cancelBtn.focus();
        });
      } else if (this.returnFocus && typeof this.returnFocus.focus === "function") {
        this.returnFocus.focus();
        this.returnFocus = null;
      }
    },
  },
  methods: {
    trapFocus(event) {
      const root = this.$refs.card;
      if (!root) return;
      const items = root.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },
  },
};
</script>
